'use strict';

const isStopBetweenFlights = (prevSection, section) => {
    return prevSection.flight
        && section.flight;
};

const isStopBetweenTrains = (prevSection, section) => {
    return !prevSection.flight
        && !section.flight;
};

const isSameAirport = (prevSection, section) => {
    return isStopBetweenFlights(prevSection, section)
        && prevSection.arrivalLocation.geoNodeId === section.departureLocation.geoNodeId;
};

const hasChangeOfAirport = (prevSection, section) => {
    return isStopBetweenFlights(prevSection, section)
        && prevSection.arrivalLocation.geoNodeId !== section.departureLocation.geoNodeId;
};

const hasChangeOfTerminal = (prevSection, section) => {
    return isSameAirport(prevSection, section)
        && !Odigeo._.isEmpty(prevSection.arrivalTerminal)
        && !Odigeo._.isEmpty(section.departureTerminal)
        && prevSection.arrivalTerminal !== section.departureTerminal;
};

const hasChangeOfFlightCarrier = (prevSection, section) => {
    return isStopBetweenFlights(prevSection, section)
        && prevSection.carrier.code !== section.carrier.code;
};

const hasChangeToFlight = (prevSection, section) => {
    return !prevSection.flight
        && section.flight;
};

const hasChangeOfTrainStation = (prevSection, section) => {
    return isStopBetweenTrains(prevSection, section)
        && prevSection.arrivalLocation.geoNodeId !== section.departureLocation.geoNodeId;
};

const hasChangeOfTrainCarrier = (prevSection, section) => {
    return isStopBetweenTrains(prevSection, section)
        && prevSection.carrier.code !== section.carrier.code;
};

const hasChangeToTrain = (prevSection, section) => {
    return prevSection.flight
        && !section.flight;
};

const hasChangeOfCountry = (prevSection, section) => {
    return prevSection.departureLocation.countryCode !== section.departureLocation.countryCode;
};

const hasChangeOfCountryInAnySection = (segments) => {
    return segments.some((segment) => {
        return segment.sections.some((section, index) => {
            const nextSection = segment.sections[index + 1];
            return nextSection ?
                hasChangeOfCountry(section, nextSection)
                : false;
        });
    });
};

module.exports = {
    isStopBetweenFlights,
    isStopBetweenTrains,
    isSameAirport,
    hasChangeOfAirport,
    hasChangeOfTerminal,
    hasChangeOfFlightCarrier,
    hasChangeToFlight,
    hasChangeOfTrainStation,
    hasChangeOfTrainCarrier,
    hasChangeToTrain,
    hasChangeOfCountry,
    hasChangeOfCountryInAnySection,
};
